module.exports = __webpack_public_path__ + "img/g1.339556b6.jpg";